module.exports = __webpack_public_path__ + "img/stas.6385809b.png";